/** Shared with real grid and skeleton so layout math stays in sync. */

export const DASHBOARD_GRID_COLS = 12;
export const DASHBOARD_ROW_HEIGHT = 60;
export const DASHBOARD_GRID_MARGIN: [number, number] = [16, 16];
export const DASHBOARD_GRID_CONTAINER_PADDING: [number, number] = [0, 16];
